import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { ClientSidePermissionListingComponent } from '../permission-container/client-side-permission/client-side-permission-listing/client-side-permission-listing.component';
import { ClientSidePermissionAddComponent } from '../permission-container/client-side-permission/client-side-permissiont-add/client-side-permission-add.component';
import { ViewColumn } from '../../../view-column';
import { ClientSidePermissionEditComponent } from '../permission-container/client-side-permission/client-side-permissiont-edit/client-side-permission-edit.component';
import { RolePricingSchemeLinkListingComponent } from '../permission-container/role-pricing-scheme-link/role-pricing-scheme-link-listing/role-pricing-scheme-link-listing.component';
import { RolePricingSchemeLinkAddComponent } from '../permission-container/role-pricing-scheme-link/role-pricing-scheme-link-add/role-pricing-scheme-link-add.component';
import { RolePricingSchemeLinkEditComponent } from '../permission-container/role-pricing-scheme-link/role-pricing-scheme-link-edit/role-pricing-scheme-link-edit.component';

@Injectable()

// This is where we need to change the view columns.
export class RolePricingSchemeLinkPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, RolePricingSchemeLinkListingComponent, 'Role Pricing Scheme Link Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, RolePricingSchemeLinkListingComponent, 'Role Pricing Scheme Link Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, RolePricingSchemeLinkAddComponent, 'Add Role Pricing Scheme Link', {
        deactivateReturn: false,
      }),
      new ViewColumn(2, RolePricingSchemeLinkEditComponent, 'Edit Role Pricing Scheme Link', {
        deactivateReturn: false,
        deleteConfirmation: false
      }),
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
